// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"b749902e","740":"11d2f15e"}[chunkId] + ".chunk.css";
};